export default "__VITE_ASSET__Bei7rTtK__"